import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'Sofía M.',
  city: 'Santiago 🇨🇱'
}, {
  name: 'Valentina P.',
  city: 'Lima 🇵🇪'
}, {
  name: 'Carmen G.',
  city: 'Bogotá 🇨🇴'
}, {
  name: 'Rosa A.',
  city: 'Ciudad de México 🇲🇽'
}, {
  name: 'Lucía T.',
  city: 'Madrid 🇪🇸'
}, {
  name: 'Marta E.',
  city: 'Buenos Aires 🇦🇷'
}];
export function SalesPopup() {
  const [current, setCurrent] = useState<number | null>(null);
  const [minutesAgo, setMinutesAgo] = useState(4);
  useEffect(() => {
    let idx = 0;
    let hideTimer: number;
    const show = () => {
      setMinutesAgo(Math.floor(Math.random() * 8) + 2);
      setCurrent(idx % buyers.length);
      idx += 1;
      hideTimer = window.setTimeout(() => setCurrent(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const interval = window.setInterval(show, 16000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const buyer = current !== null ? buyers[current] : null;
  return <AnimatePresence data-id="element-200" data-mp="29pskib7ipzf5">
      {buyer && <motion.div initial={{
      x: -120,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -120,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 24
    }} className="fixed bottom-20 left-3 z-40 w-[17rem] rounded-2xl bg-white p-3.5 shadow-2xl ring-1 ring-mauve-soft/50 sm:bottom-24" data-id="element-201" data-mp="29or7403150u9">
          <div className="flex items-start gap-3" data-id="element-202" data-mp="2sgjosycnezmo">
            <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-sage/15" data-id="element-203" data-mp="2sgtf6n1lv8sw">
              <CheckCircle2Icon className="h-6 w-6 text-sage" data-id="element-204" data-mp="2xeljkgjfsndz" />
            </div>
            <div className="min-w-0" data-id="element-205" data-mp="y3kdvij7qtlq">
              <p className="flex items-center gap-1 text-xs font-bold text-plum" data-id="element-206" data-mp="y4lsty3co08q">
                <span className="h-2 w-2 flex-none rounded-full bg-green-500" data-id="element-207" data-mp="131lvdz0zqkv3" />
                Compra verificada
              </p>
              <p className="mt-0.5 truncate text-sm font-bold text-plum" data-id="element-208" data-mp="q1t8ibo5zyue">
                🧶 {buyer.name} — {buyer.city}
              </p>
              <p className="text-xs text-plum/65" data-id="element-209" data-mp="14zln91lw0j7j">
                Compró el Sistema ¿Qué Tejo Hoy?™
              </p>
              <p className="mt-0.5 text-[11px] text-plum/45" data-id="element-210" data-mp="zyfs6x4r8juu">
                Hace {minutesAgo} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}